var _style, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolcanNegroTrasn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{opacity:0.5;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 512,
    height: 512
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_5_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    className: "st1",
    d: "M166.3,121l-65.9,131.1l0.4,0.2c13.2,7.5,24.8,5.8,31-4.6c8-13.5,16.1-22.5,29.7-22.5 c13.9,0,20.2,11.6,24.8,20l8.2,14.3c5.7,10,8.9,14.9,15.5,14.9c5,0,10.8-4.6,11.9-12.5l3.6-26.8c2-15.2,13-25.8,26.6-25.8 c13.2,0,18.8,10.4,23.2,18.7c0.8,1.5,1.6,3.1,2.5,4.5c3.1,5.3,11.3,12.7,22,16.3c7.4,2.5,12.2,6.2,16.1,9.1 c4.4,3.4,7.3,5.6,13.1,5.9c7.2,0.4,14.9-3.4,19.6-34.5c1.3-8.8,6.2-16.2,13.1-19.9c3.5-1.8,8.8-3.4,15.5-1.9l-42.3-86.5 c-11.1,19.8-43.6,33.5-84.2,33.5C210,154.7,177.3,141,166.3,121z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_7_",
    className: "st1",
    d: "M446.3,349.1L386,225.7l-7.5-3.5c-4.3-2-7.8-2.3-10.6-0.7c-3,1.6-5.4,5.5-6.1,10 c-2.2,14.2-7.3,47.3-33.6,45.9c-10-0.6-15.6-4.8-20.5-8.5c-3.5-2.7-6.9-5.2-12.3-7c-15-5.2-25.1-15.3-29.3-22.4 c-0.9-1.6-1.8-3.3-2.7-4.9c-4.5-8.5-6.7-11.7-11.4-11.7c-7.9,0-12.4,7.1-13.3,14.1l-3.5,26.8c-1.8,13.8-12.6,24.1-25.2,24.1 c-14.7,0-21.2-11.3-26.9-21.2l-8.6-15.1c-4.4-8.1-7.5-13-13.1-13c-5.6,0-10.2,2.5-18.1,15.9c-10,16.8-29.2,20.5-48.9,9.5 L27.1,398.2c0,14.7,33.4,9.5,49.2,6.1l46.1-105l12.3,5.4L89.7,407c16,13.1,64.8,48.1,96.7,16.9l2.8-53.9l13.4,0.7l-2.7,50.4 c14.8,6.8,48.1,20.3,79.1,20.3c69.6,0,103.2-27.7,114.7-40.2L364,320.7l12.6-4.6l32.7,88.5c25.7,19.6,28.7-5.4,75.6,8.6 L446.3,349.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_6_",
    className: "st1",
    d: "M325.6,105.9c0-2-0.4-3.9-1.1-5.8c0,0,0-0.1,0-0.1v0c-6.1-16.7-36.7-29.4-73.7-29.4 c-37,0-67.7,12.7-73.7,29.4v0c0,0,0,0,0,0.1c-0.3,0.9-0.6,1.8-0.8,2.8c-0.2,1-0.3,2-0.3,3c0,19.6,33.5,35.4,74.9,35.4 C292,141.3,325.6,125.4,325.6,105.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolcanNegroTrasn);
export default __webpack_public_path__ + "static/media/volcan_negro_trasn.d5cfd9f7a2b4b9bcefc42e04c30b3cca.svg";
export { ForwardRef as ReactComponent };